var checkEAQuizSubscriptionPartner = function checkEAQuizSubscriptionPartner(
    selectedLevel,
    exam_data
  ) {
      console.log(
        'checking----------------------->',
        exam_data ,selectedLevel
      );
    var flag = false;
    for (var i = 0; i < exam_data.length; i++) {
      // console.log("1");
  
      if (exam_data[i].exam_name === selectedLevel) {
        // console.log("2");
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (exam_data[i].levels[j].package_id === 51) {
              flag = false;
            }
            if (exam_data[i].levels[j].package_id === 52) {
              flag = true;
            }
            if (exam_data[i].levels[j].package_id === 53) {
              flag = true;
            }
          }
        } else {
          // console.log("6");
          flag = false;
        }
        // break;
      } else {
        flag = false;
      }
    }
  
    return flag;
  };
export default checkEAQuizSubscriptionPartner;



// WEBPACK FOOTER //
// ./src/views/RestAPI/PartnerSubscription/EAQuizSubscriptionPartner.js